import {autoserializeAs} from "dcerialize";

export class NewsAuthor {
  @autoserializeAs(() => String)
  public readonly username: string;
  @autoserializeAs(() => String)
  public readonly fullName: string;
  @autoserializeAs(() => String)
  public readonly fediverseHandle?: string;
}
